import { render, staticRenderFns } from "./settings-block.vue?vue&type=template&id=847de69e&scoped=true&"
import script from "./settings-block.vue?vue&type=script&lang=js&"
export * from "./settings-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847de69e",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fscripts%2Fsettings-block.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/amo?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fscripts%2Fsettings-block.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "./settings-block.vue?vue&type=custom&index=2&blockType=i18n"
if (typeof block2 === 'function') block2(component)

export default component.exports